<template>
  <div
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
    "
  >
    <div
      class="card-panel bg-white shadow-hover shadow-sm mt-0 border border-color"
      style="min-width: 35rem"
    >
      <div class="img-logo">
        <a
          href="https://share.linx.com.br/display/SHOPLINXMICRPUB/Linx+Scarf"
          target="_blank"
          title="Ajuda"
          class="iIconeAjuda"
        >
          <i class="fa fa-question" aria-hidden="true"></i>
        </a>
      </div>
      <div class="row" style="margin-bottom: 20px">
        <div
          class="col-4 d-flex mx-auto"
          style="align-items: center; width: 90px"
        >
          <img
            src="@/assets/img/logo-scarf.png"
            alt="logo-scarf"
            style="width: 24px; height: 24px"
          />
          <h1 class="h1 ml-2">{{ titulo }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>Não pude detectar a sua versão do Scarf!</p>
          <p>Escolha uma das opções abaixo:</p>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-12 mb-2">
          <button class="btn btn-primary w-100" @click="instalarAplicativo">
            <i class="fas fa-download"></i>
            <span class="ml-1">Instale agora</span>
          </button>
        </div>
        <div class="col-12">
          <button class="btn btn-secondary w-100" @click="iniciarAplicativo">
            <i class="fas fa-play-circle"></i>
            <span class="ml-1">Inicie o aplicativo</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AvisoScarf",

  setup() {
    const titulo = "Scarf";

    const instalarAplicativo = () => {
      window.open(
        "https://setupbr.microvix.com.br/scarf/Linx_Microvix_Scarf.exe",
        "_self"
      );
    };
    const iniciarAplicativo = () => {
      window.open("linxscarf:", "_self");
    };

    return { titulo, instalarAplicativo, iniciarAplicativo };
  },
});
</script>

<style>
body {
  background-color: #ebebeb;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.border-color {
  border-color: #5b2e90 !important;
  color: #5b2e90;
}

.card-panel {
  padding: 15px;
}
.shadow-hover {
  transition: 0.7s box-shadow ease;
}

.card-panel .h1 {
  color: #626262;
  cursor: pointer;
  font-family: "Dosis", sans-serif;
  font-size: 1.5rem !important;
  text-transform: uppercase;
}

.bg-white {
  background-color: white;
}

.border-color {
  border: 1px solid;
  border-color: #5b2e90 !important;
  color: #5b2e90;
}

.btn {
  font-family: "Dosis", sans-serif;
  font-weight: 500;
  font-size: 15px;
  text-transform: uppercase;
  box-sizing: border-box;
  border-radius: 0;
  border: 0;
  outline: 0;
  transition: background-color 0.2s ease;
  width: 100%;
  height: 2.5rem;
}

.btn-primary {
  color: #fff;
  background-color: #5b2e90;
}

.btn-secondary {
  color: #000;
  background-color: #ffb200;
}
</style>
